import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import About from '@/components/About'
import Objectives from '@/components/Objectives'
import Events from '@/components/Events'
import Sponsor from '@/components/Sponsor'
import Gallery from '@/components/Gallery'
import PhotoGallery from '@/components/GalleryItems/PhotoGallery'
import VideoGallery from '@/components/GalleryItems/VideoGallery'
import Contact from '@/components/Contact'
import Membersroundup from '@/components/Membersroundup'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/Objectives',
      name: 'Objectives',
      component: Objectives
    },
    {
      path: '/Events',
      name: 'Events',
      component: Events
    }    ,
    {
      path: '/Sponsor',
      name: 'Sponsor',
      component: Sponsor
    },
    {
      path: '/PhotoGallery',
      name: 'PhotoGallery22',
      component: PhotoGallery
    }
    ,
    {
      path: '/VideoGallery2',
      name: 'VideoGallery2',
      component: VideoGallery
    }
    ,
    {
      path: '/Gallery/:item',
      name: 'Gallery',
      component: Gallery,
      children: [
        {
          path: 'PhotoGallery',
          name: 'PhotoGallery',
          component: PhotoGallery
        },
        {
          path: 'VideoGallery',
          name: 'VideoGallery',
          component: VideoGallery
        }  
      ]
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/Membersroundup',
      name: 'Membersroundup',
      component: Membersroundup
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js